import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20illustration%20of%20a%20dreamy%20library%20or%20reading%20space%20with%20floating%20books%20and%20pages%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20soft%20atmospheric%20lighting%2C%20abstract%20geometric%20elements%2C%20minimalist%20composition%2C%20cozy%20and%20inviting%20vibe%2C%20artistic%20flat%20illustration%20style%20with%20gentle%20gradients&width=1600&height=620&seq=hero-manga-bg&orientation=landscape"
        alt="女神漫画网 - 下拉式在线阅读平台"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="text-2xl md:text-5xl font-bold text-white mb-4 md:mb-6 leading-tight max-w-[800px]">
          女神漫画 · 下拉式沉浸阅读
        </h1>
        <p className="text-sm md:text-lg text-white/80 mb-8 md:mb-10 max-w-[600px] leading-relaxed">
          专为手机端优化的下拉式在线阅读平台，流畅滚动看全集。涵盖韩漫、日漫、国漫等热门作品，无需翻页，沉浸式追漫体验。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/all"
            className="px-8 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap transition-all duration-300 cursor-pointer"
          >
            立即阅读
          </Link>
          <Link
            to="/category/korean"
            className="px-8 py-3 rounded-full bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white text-sm font-medium whitespace-nowrap transition-all duration-300 cursor-pointer"
          >
            热门韩漫
          </Link>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-white/60">
        <span className="text-xs">向下滚动</span>
        <i className="ri-arrow-down-line animate-bounce text-sm"></i>
      </div>
    </section>
  );
}